import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import '../../App.css';
import '../../Styles/Admin-sidebar.css';

const SidebarMenu = ({ handleComponentSelect }) => {
    const navigate = useNavigate();
    const [collapseSidebar, setCollapseSidebar] = useState(false);
    const [userRole, setUserRole] = useState('');
    const [activeFlag, setActiveFlag] = useState('');

    useEffect(() => {
        setUserRole(sessionStorage.getItem("role"))
        const activeLink = sessionStorage.getItem("activeLink")
        if (activeLink) {
            setActiveFlag(activeLink); // Update active flag
            navigate(`/admin-dashboard/${activeLink}`);
        }
    },
        []
    );

    const adminMenu = [
        { id: 'Verifications', condition: true, Flag: 'Verifications', icon: 'Verifications-icon.svg', text: 'Verifications' },
        { id: 'Complaints', condition: true, Flag: 'Complaints', icon: 'complaints-icon.svg', text: 'Complaints' },
        { id: 'Panels', condition: true, Flag: 'Panels', icon: 'panels-icon.svg', text: 'Panels' },
        { id: 'analytics-reports', condition: true, Flag: 'Reports', icon: 'laborders-icon.svg', text: 'Reports' },
        { id: 'Tests', condition: true, Flag: 'Tests', icon: 'test-icon.svg', text: 'Tests' },
        { id: 'Faq', condition: true, Flag: 'Faq', icon: 'faq-icon.svg', text: 'Faq' },
        { id: 'Transactions', condition: true, Flag: 'Transactions', icon: 'transaction-icon.svg', text: 'Transactions' },
        { id: 'Subscriptions', condition: true, Flag: 'Subscriptions', icon: 'subscriptions-icon.svg', text: 'Subscriptions' },
        { id: 'Coupons', condition: true, Flag: 'Coupons', icon: 'coupons-icon.svg', text: 'Coupons' },
        { id: 'Users', condition: true, Flag: 'Users', icon: 'users-icon.svg', text: 'Users' },
        { id: 'SpecialitiesList', condition: true, Flag: 'SpecialitiesList', icon: 'specialists-icon.svg', text: 'Specialities' },
        { id: 'Wellness', condition: true, Flag: 'Wellness', icon: 'wellness-icon.svg', text: 'Wellness' },
        { id: 'Healthtips', condition: true, Flag: 'Healthtips', icon: 'healthtips-icon.svg', text: 'HealthTips' },
        { id: 'GenerateReports', condition: true, Flag: 'GenerateReports', icon: 'generatereports-icon.svg', text: 'Generate Reports' },
        { id: 'LabOrders', condition: true, Flag: 'LabOrders', icon: 'laborders-icon.svg', text: 'Lab Orders' },
        { id: 'Promotions', condition: true, Flag: 'Promotions', icon: 'laborders-icon.svg', text: 'Promotions' },
        // { id: 'analytics-reports', condition: true, Flag: 'Reports', icon: 'laborders-icon.svg', text: 'Reports' },

    ];
    const superadminMenu = [
        { id: 'Admins', condition: true, Flag: 'Admins', icon: 'Verifications-icon.svg', text: 'User Lists' },
        { id: 'SubscriptionPackages', condition: true, Flag: 'SubscriptionPackages', icon: 'Verifications-icon.svg', text: 'Subscription Packages' },
        { id: 'referenceTestsVerification', condition: true, Flag: 'referenceTestsVerification', icon: 'Verifications-icon.svg', text: 'Tests Verification' }
    ];
    const analytics = [
        { id: 'analytics', condition: true, Flag: 'analytics', icon: 'laborders-icon.svg', text: 'analytics' },
    ]
    const labExecutiveMenu = [
        // { id: 'referenceTestsVerification', condition: true, Flag: 'referenceTestsVerification', icon: 'Verifications-icon.svg', text: 'Tests Verification' }
        { id: 'LabExecutiveTests', condition: true, Flag: 'LabExecutiveTests', icon: 'Verifications-icon.svg', text: 'Tests' }
    ]
    const wellnessCoordinatorMenu = [
        // { id: 'referenceTestsVerification', condition: true, Flag: 'referenceTestsVerification', icon: 'Verifications-icon.svg', text: 'Tests Verification' }
        { id: 'WellnessProgrammeConfig', condition: true, Flag: 'WellnessProgrammeConfig', icon: 'Verifications-icon.svg', text: 'Wellness Programme Config' }
    ]

    const tabClick = (tabId) => {
        sessionStorage.setItem('activeLink', tabId);

        // Update the active flag
        setActiveFlag(tabId);

        // Navigate to the respective page
        navigate(`/admin-dashboard/${tabId}`);


        handleComponentSelect(tabId)
    };
    const tabonClick = () => {

    }
    return (
        <div className={`sidebarMenu ${!collapseSidebar ? 'bg1 fc27' : 'fc4'}`} id="sidemenu">
            <div id="14993" className="flex-grow-1">
                {
                    userRole === "ADMIN" ? (
                        <ul className="sideMenuList" id="mainlist">
                            {adminMenu.map((item) =>
                                item.condition ? (
                                    <li className="menuRow menu-item " id={item.id} key={item.id} onClick={() => tabClick(item.id)}>
                                        <a className={`flex flex-col  items-center ${item.id === activeFlag ? 'active' : ''}`}>
                                            <img src={`./images/Admin-Newsidebar-images/${item.icon}`} className="iconsize" alt="" />
                                            <p className="m-0">
                                                <span className="icontext">{item.text}</span>
                                            </p>
                                        </a>
                                    </li>
                                ) : null
                            )}
                        </ul>
                    ) : ''
                }

                {
                    userRole === "SUPERADMIN" ? (
                        <ul className="sideMenuList" id="mainlist">
                            {superadminMenu.map((item) =>
                                item.condition ? (
                                    <li className="menuRow menu-item " id={item.id} key={item.id} onClick={() => tabClick(item.id)}>
                                        <a className={`flex flex-col  items-center ${item.Flag === activeFlag ? 'active' : ''}`}>
                                            <img src={`./images/Admin-Newsidebar-images/${item.icon}`} className="iconsize" alt="" />
                                            <p className="m-0">
                                                <span className="icontext">{item.text}</span>
                                            </p>
                                        </a>
                                    </li>
                                ) : null
                            )}
                        </ul>
                    ) : ''
                }
                {
                    userRole === "PROMOTIONOFFEREXECUTIVE" ? (
                        <ul className="sideMenuList" id="mainlist">
                            {superadminMenu.map((item) =>
                                item.condition ? (
                                    <li className="menuRow menu-item " id="coupons" key="coupons" to="/admin-dashboard/Coupons" onClick={() => tabonClick('Coupons')}>
                                        <a className={`flex flex-col  items-center ${item.Flag === activeFlag ? 'active' : ''}`}>
                                            <img src={`./images/Admin-Newsidebar-images/${item.icon}`} className="iconsize" alt="" />
                                            <p className="m-0">
                                                <span className="icontext">{item.text}</span>
                                            </p>
                                        </a>
                                    </li>
                                ) : null
                            )}
                        </ul>
                    ) : ''
                }
                {
                    userRole === "ANALYTICS" ? (
                        <ul className="sideMenuList" id="mainlist">
                            {analytics.map((item) =>
                                item.condition ? (
                                    <li className="menuRow menu-item " id={item.id} key={item.id} to="/admin-dashboard/analytics" onClick={() => tabClick(item.id)}>
                                        <a className={`flex flex-col  items-center ${item.Flag === activeFlag ? 'active' : ''}`}>
                                            <img src={`./images/Admin-Newsidebar-images/${item.icon}`} className="iconsize" alt="" />
                                            <p className="m-0">
                                                <span className="icontext">{item.text}</span>
                                            </p>
                                        </a>
                                    </li>
                                ) : null
                            )}
                        </ul>
                    ) : ''
                }
                {
                    userRole === "LABEXECUTIVE" ? (
                        <ul className="sideMenuList" id="mainlist">
                            {labExecutiveMenu.map((item) =>
                                item.condition ? (
                                    <li className="menuRow menu-item " id={item.id} key={item.id} to="/admin-dashboard/labExecutive" onClick={() => tabClick(item.id)}>
                                        <a className={`flex flex-col  items-center ${item.Flag === activeFlag ? 'active' : ''}`}>
                                            <img src={`./images/Admin-Newsidebar-images/${item.icon}`} className="iconsize" alt="" />
                                            <p className="m-0">
                                                <span className="icontext">{item.text}</span>
                                            </p>
                                        </a>
                                    </li>
                                ) : null
                            )}
                        </ul>
                    ) : ''
                }
                {
                    userRole === "PROJECTCOORDINATOR" ? (
                        <ul className="sideMenuList" id="mainlist">
                            {wellnessCoordinatorMenu.map((item) =>
                                item.condition ? (
                                    <li className="menuRow menu-item " id={item.id} key={item.id} to="/admin-dashboard/WellnessProgrammeConfig" onClick={() => tabClick(item.id)}>
                                        <a className={`flex flex-col  items-center ${item.Flag === activeFlag ? 'active' : ''}`}>
                                            <img src={`./images/Admin-Newsidebar-images/${item.icon}`} className="iconsize" alt="" />
                                            <p className="m-0">
                                                <span className="icontext">{item.text}</span>
                                            </p>
                                        </a>
                                    </li>
                                ) : null
                            )}
                        </ul>
                    ) : ''
                }

            </div>
        </div>
    );
};
export default SidebarMenu;